/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableERP } from "@finanedi.es/storybook"
import { useQuery } from "@tanstack/react-query"
import { getAsientoContableModelo349 } from "api/AsientoContable.service"
import { PERIODO } from "api/Types/Periodo"
import { Dropdown } from "primereact/dropdown"
import { Trans, useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { HandleTabs } from "../../DetalleImpuestos"
import { RedirectParams } from "../constants"
import { MODELO_349_COLUMNS } from "./Modelo349Columns"

export const Modelo349 = ({
  props: { year, handleYearSelection, yearsOptionList },
}: {
  props: HandleTabs
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const navigate = ({ route, periodo, modelo, year }: RedirectParams) => {
    history.push(route, {
      periodo,
      modelo,
      year,
    })
  }

  const fetchModelo349 = async () => {
    const data = await getAsientoContableModelo349({
      Anyo: year.selectedYear,
      Periodo: PERIODO.TRIMESTRAL,
    })
    return data
  }

  const { data, isLoading } = useQuery({
    queryKey: ["modelo349", year.selectedYear],
    queryFn: fetchModelo349,
    select: (response) => {
      const periodos = response?.periodos ?? []
      return [
        ...periodos,
        {
          periodo: undefined,
          baseImponible: response?.periodos?.reduce(
            (acc, curr) => acc + (curr.baseImponible ?? 0),
            0
          ),
          iva: response?.periodos?.reduce(
            (acc, curr) => acc + (curr.iva ?? 0),
            0
          ),
        },
      ]
    },
    refetchOnWindowFocus: true,
  })

  return (
    <>
      <div className='tw-py-4'>
        <div className='tw-rounded-t-xl tw-flex tw-bg-simple-10 tw-justify-between tw-items-center '>
          <p className='tw-py-5 tw-pl-6 tw-m-0 tw-text-base'>
            <Trans
              i18nKey='taxSummary.tableTitle349'
              className=''
              components={[
                <span
                  className='tw-font-medium tw-contents !tw-text-lg !tw-m-0'
                  key='0'
                />,
              ]}
            />
          </p>
          <Dropdown
            id='rangosFechaIvaImpuesto'
            name='rangosFechaivaImpuesto'
            className='tw-rounded-md tw-mr-6'
            value={year.selectedYear}
            options={yearsOptionList}
            onChange={handleYearSelection}
          />
        </div>
        <TableERP
          columns={MODELO_349_COLUMNS(t, navigate, year.selectedYear)}
          className='tw-h-full tw-min-h-60'
          columnResizeMode='expand'
          value={data ?? []}
          showGridlines
          dataKey='id'
          lazy
          scrollable
          size='small'
          loading={isLoading}
        />
      </div>
    </>
  )
}
